<template>
  <el-dialog
    :visible.sync="showDialog"
    :width="modalWidth"
    top="15vh"
    :modal-append-to-body="false"
    :before-close="handleClose"
    custom-class="custom-scrollable"
  >
    <div class="font-normal mx-4">
      <div class="-mt-10">
        <!-- fixed header -->
        <div class="dialog-header border-dash">
          <div class="flex w-full items-start">
            <div class="pr-2">
              <arrow-down
                v-if="
                  transaction.transactionType === $transactionType.DEPOSIT ||
                  transferType === $transactionType.DEPOSIT
                "
              />
              <arrow-up v-else />
            </div>
            <div
              class="text-xl md:text-2xl capitalize text-root-2 font-semibold flex justify-center"
            >
              {{
                dialogType === 'terminal'
                  ? 'Transfer'
                  : batchTransactionDetails
                  ? transferType + ' Batch'
                  : transaction.transactionType || transferType
              }}
            </div>
          </div>
          <div
            class="w-full mb-4 flex justify-end text-xs text-root-4 text-center font-normal"
          >
            <div class="lg:ml-12 ml-3 mr-3 font-bold flex flex-col items-end">
              <div class="text-root-2 text-lg md:text-2xl pt-1">
                {{
                  transaction.transactionType === $transactionType.DEPOSIT ||
                  transferType === $transactionType.DEPOSIT
                    ? '+'
                    : '-'
                }}
                {{
                  parseMoneyAll(
                    transaction.amount,
                    transaction.currency || currency
                  )
                }}
              </div>
              <div
                v-if="transaction.status === 'completed'"
                class="text-xs mb-3 font-normal flex items-center text-green"
              >
                {{
                  transaction.transactionType === $transactionType.DEPOSIT ||
                  transferType === $transactionType.DEPOSIT
                    ? '+' +
                      parseMoneyAll(
                        transaction.amount,
                        transaction.currency || currency
                      )
                    : '-' +
                      parseMoneyAll(
                        transaction.amount,
                        transaction.currency || currency
                      )
                }}
              </div>
              <div
                v-else
                class="text-xs mb-1 font-normal text-gray-40 capitalize flex items-center"
              >
                {{ '-' }}
              </div>
            </div>
          </div>
        </div>
        <!-- body -->
        <div class="mt-4" :class="{ 'h-64': dialogType === 'transfer' }">
          <div
            v-if="!batchTransactionDetails"
            class="flex pb-4 items-center justify-between"
          >
            <div class="text-root-4">User ID:</div>
            <div class="flex items-center w-3/5 justify-end">
              <div class="text-root-2 truncate-text">
                {{ transaction.customerID }}
              </div>
              <div
                class="cursor-pointer mb-1 ml-2"
                v-clipboard:copy="transaction.customerID"
                v-clipboard:success="onCopy"
                v-clipboard:error="onError"
              >
                <copy-icon />
              </div>
            </div>
          </div>
          <div
            v-if="!batchTransactionDetails"
            class="flex pb-4 items-center justify-between"
          >
            <div class="text-root-4">Transaction ID:</div>
            <div class="flex items-center w-3/5 justify-end">
              <div class="text-root-2 truncate-text">
                {{ transaction.id }}
              </div>
              <div
                class="cursor-pointer mb-1 ml-2"
                v-clipboard:copy="transaction.id"
                v-clipboard:success="onCopy"
                v-clipboard:error="onError"
              >
                <copy-icon />
              </div>
            </div>
          </div>
          <div class="flex pb-4 justify-between">
            <p class="text-root-2 font-normal">Batch ID:</p>
            <p class="">
              {{
                batchTransactionDetails
                  ? routeDetails.id
                  : parseBatchDate(transaction.batchDate) || '-'
              }}
            </p>
          </div>
          <div class="flex pb-4 justify-between">
            <p class="text-root-2 font-normal">Currency</p>
            <p class="">
              {{ transaction.currency || '-' }}
            </p>
          </div>
          <div class="flex pb-4 justify-between">
            <p class="text-root-2 font-normal">
              {{ batchTransactionDetails ? 'Date:' : 'Date & Time:' }}
            </p>
            <p v-if="batchTransactionDetails">
              {{ transaction.batchDate }}
            </p>
            <p v-else>
              {{ $dayjs(transaction.createdAt).format('DD MMM YY') }} |
              {{ parseTime(transaction.createdAt) }}
              {{ $dayjs(transaction.createdAt).format(' A') }}
            </p>
          </div>
          <!-- transaction status -->
          <div class="flex pb-4 justify-between">
            <p class="text-root-2 font-normal">Status:</p>
            <p
              class="py-1.5 px-2 text-center text-sm capitalize flex items-center justify-center font-bold border-none rounded"
              :class="statusClass(transaction.status)"
            >
              {{ transaction.status }}
            </p>
          </div>
          <template
            v-if="
              dialogType === 'terminal' ||
              (transferType === 'transfer' && !batchTransactionDetails)
            "
          >
            <el-collapse>
              <el-collapse-item title="Recipient Bank Details" name="1">
                <div class="pl-3 pt-2">
                  <div class="flex pb-2 items-center justify-between">
                    <div class="text-root-4">Country:</div>
                    <div style="word-break: normal" class="text-root-1">
                      {{ transaction.destination.bankDetails.country || '-' }}
                    </div>
                  </div>
                  <div class="flex pb-2 items-center justify-between">
                    <div class="text-root-4">Name:</div>
                    <div style="word-break: normal" class="text-root-1">
                      {{ transaction.destination.bankDetails.bankName || '-' }}
                    </div>
                  </div>
                  <div class="flex pb-2 items-center justify-between">
                    <div class="text-root-4">Account Number:</div>
                    <div class="text-root-1">
                      {{
                        transaction.destination.bankDetails.accountNumber || '-'
                      }}
                    </div>
                  </div>
                  <div class="flex pb-2 items-center justify-between">
                    <div class="text-root-4">Account Name:</div>
                    <div class="text-root-1">
                      {{
                        transaction.destination.bankDetails.accountName || '-'
                      }}
                    </div>
                  </div>
                  <div class="flex items-center justify-between">
                    <div class="text-root-4">Swift Code:</div>
                    <div class="text-root-1">
                      {{ transaction.destination.bankDetails.swiftCode || '-' }}
                    </div>
                  </div>
                </div>
              </el-collapse-item>
            </el-collapse>
            <el-collapse>
              <el-collapse-item title="Recipient Details" name="2">
                <div class="pl-3 pt-2">
                  <div class="flex items-center justify-between">
                    <div class="text-root-4">Country:</div>
                    <div style="word-break: normal" class="text-root-1">
                      {{
                        transaction.destination.personalDetails.country || '-'
                      }}
                    </div>
                  </div>
                  <div class="flex items-center justify-between">
                    <div class="text-root-4">Name:</div>
                    <div style="word-break: normal" class="text-root-1">
                      {{ transaction.destination.personalDetails.name || '-' }}
                    </div>
                  </div>
                  <div class="flex items-center justify-between">
                    <div class="text-root-4">Address:</div>
                    <div class="text-root-1">
                      {{
                        transaction.destination.personalDetails.address || '-'
                      }}
                    </div>
                  </div>
                  <div class="flex items-center justify-between">
                    <div class="text-root-4">City:</div>
                    <div class="text-root-1">
                      {{ transaction.destination.personalDetails.city || '-' }}
                    </div>
                  </div>
                </div>
              </el-collapse-item>
            </el-collapse>
            <!-- reason -->
            <el-collapse>
              <el-collapse-item name="1" title="Reason">
                <div class="pl-3 pt-2">
                  <div class="flex items-center justify-between">
                    <div class="text-root-4">Reason</div>
                    <div style="word-break: normal" class="text-root-1">
                      {{ transaction.reason || transaction.cancelReason }}
                    </div>
                  </div>
                </div>
              </el-collapse-item>
            </el-collapse>
            <el-collapse>
              <el-collapse-item name="1" title="Reference">
                <div class="pl-3 pt-2">
                  <div class="flex items-center justify-between">
                    <div class="text-root-4">Reference Name</div>
                    <div class="text-root-1">
                      {{ transaction.reference || '-' }}
                    </div>
                  </div>
                </div>
              </el-collapse-item>
            </el-collapse>
          </template>
          <div
            v-if="
              transaction.status === 'failed' ||
              transaction.status === 'cancelled'
            "
            class="flex justify-between"
          >
            <p class="text-root-2 font-normal">Reason:</p>
            <p style="word-break: normal" class="text-root-1">
              {{ transaction.cancelReason }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import breakpoints from '@/utils/breakpoints.js'
import {
  MaskID,
  parseBatchDate,
  ParseMoneyAll,
  ParseTime
} from '@/utils/helpers'
import statusClass from '@/mixins/global.js'
export default {
  name: 'ExternalApiTransactionDialog',
  mixins: [statusClass],
  props: {
    showDialog: {
      type: Boolean,
      default: false
    },
    transaction: {
      type: Object,
      default: () => {}
    },
    dialogType: {
      type: String,
      default: ''
    },
    transferType: {
      type: String,
      default: ''
    },
    currency: {
      type: String,
      default: ''
    },
    batchTransactionDetails: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    ArrowUp: () => import('@/assets/icons/ArrowUp.vue'),
    ArrowDown: () => import('@/assets/icons/ArrowDown.vue'),
    CopyIcon: () => import('@/assets/icons/CopyIcon.vue')
  },
  data () {
    return {
      breakpoints
    }
  },
  computed: {
    modalWidth () {
      return breakpoints.lgAndUp ? '33%' : breakpoints.mdAndUp ? '70%' : '90%'
    },
    routeDetails () {
      return {
        id: this.$route.params.id,
        status: this.$route.query.status,
        currency: this.$route.query.currency,
        type: this.$route.query.type
      }
    }
  },
  methods: {
    handleClose () {
      this.$emit('closeDialog')
    },
    parseTime (val) {
      return ParseTime(val)
    },
    parseMoneyAll (amount, currency) {
      return ParseMoneyAll(amount, currency)
    },
    maskID (val) {
      return MaskID(val)
    },
    parseBatchDate (val) {
      return parseBatchDate(val)
    },
    onCopy: function (e) {
      this.$notify.success({
        title: 'Copied'
      })
    },
    onError: function (e) {
      this.$notify.error('Error copying to clipboard!')
    }
  }
}
</script>

<style scoped>
.grey-bg {
  background: #e0e0e0;
}
>>> .el-collapse-item__header {
  font-size: 14px;
  color: var(--text-2);
  font-weight: normal;
  border: none;
}
>>> .el-collapse {
  border: none;
}
>>> .el-collapse-item {
  border: none;
}
>>> .el-collapse-item__content {
  border: none;
}
>>> .el-collapse-item__wrap {
  border: none;
}
>>> .el-collapse-item__header.is-active {
  color: var(--primary);
}
</style>
